/**
 * countryLookup.js
 *
 * Lookup helpers for ISO 2-letter country codes.
 * Data: 266 codes from the official CBAM template, sheet "c_CodeLists".
 */

import countriesData from '../data/countries.json';

const ALL_COUNTRIES = countriesData.countries;

/**
 * Returns the full list of countries, already sorted by name.
 * @returns {Array<{ code: string, name: string }>}
 */
export const getAllCountries = () => ALL_COUNTRIES;

/**
 * Returns the country name for a given ISO code.
 * @param {string} code - e.g. "IN"
 * @returns {string} country name, or "" if not found.
 */
export const getNameForCountryCode = (code) => {
  if (!code || typeof code !== 'string') return '';
  const trimmed = code.trim().toUpperCase();
  const entry = ALL_COUNTRIES.find((c) => c.code === trimmed);
  return entry ? entry.name : '';
};

/**
 * Returns the ISO code for a given country name (case-insensitive).
 * @param {string} name - e.g. "India"
 * @returns {string} code, or "" if not found.
 */
export const getCodeForCountryName = (name) => {
  if (!name || typeof name !== 'string') return '';
  const trimmed = name.trim().toLowerCase();
  const entry = ALL_COUNTRIES.find((c) => c.name.toLowerCase() === trimmed);
  return entry ? entry.code : '';
};